import React from 'react';
import GlobalStyles from './styles/globalStyles';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import CTA from './components/CTA/CTA';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <>
      <GlobalStyles />
      <Header />
      <Hero />
      <Services />
      <CTA />
      <About />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
